import {
  homepageImageUrl,
  type HomepageContinuityContent,
} from "@/data/homepageContent";

type ContinuityRailProps = {
  content: HomepageContinuityContent;
};

export function ContinuityRail({ content }: ContinuityRailProps) {
  return (
    <div className="continuity-rail" id="continuityRail">
      <div className="continuity-band">
        <div className="continuity-links">
          {content.links.map((link) => (
            <a key={link.href} href={link.href} data-magnetic>
              {link.label}
            </a>
          ))}
        </div>
      </div>
      <div className="continuity-image-shell">
        <div className="continuity-base-layer">
          <div
            className="continuity-base surface-frame"
            id="continuityBase"
            style={{ backgroundImage: `url('${homepageImageUrl(content.base_image)}')` }}
          />
        </div>

        <div className="continuity-motion-layer">
          <div className="continuity-card" id="continuityCard">
            <div
              className="switch-layer layer-back surface-frame"
              id="cardBackLayer"
              style={{ backgroundImage: `url('${homepageImageUrl(content.card_back_image)}')` }}
            />
            <div
              className="switch-layer layer-front surface-frame"
              id="cardFrontLayer"
              style={{ backgroundImage: `url('${homepageImageUrl(content.card_front_image)}')` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
